import rootReducer from "../rootReducer";

// create our first middleware
const preventAddBooking = (store) => (next) => (action) => {
    // console.log(`Action: ${JSON.stringify(action)}`);
    // console.log(`Before: ${JSON.stringify(store.getState())}`);

    const upcomingState = [action].reduce(rootReducer, store.getState());

    const upcomingStateParse = JSON.parse(JSON.stringify(upcomingState));

    // console.log(`Upcoming State: ${JSON.stringify(upcomingState)}`);

    // pass action
    if (upcomingStateParse.booking.length > 3 ){
        alert("Sorry !! You can not ADD new booking 😔")
    }else{
        return next(action);
    }
};

export default preventAddBooking;
